const digest = '6d9129c2627f35ddcdbeb85c2884b2f4e6b4d8036bde083460704198c0d2d58b';
const css = `._timeDropdownWrapper_40tsg_1 svg{margin-right:2px}._timeDropdown_40tsg_1>div:first-child{flex-grow:1}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'timeDropdownWrapper': '_timeDropdownWrapper_40tsg_1', 'timeDropdown': '_timeDropdown_40tsg_1' };
export const timeDropdownWrapper = '_timeDropdownWrapper_40tsg_1';
export const timeDropdown = '_timeDropdown_40tsg_1';
export { css, digest };